import { Component, OnInit, Input } from '@angular/core';
import { ChartsModule } from 'ng2-charts/ng2-charts';

@Component({
  selector: 'app-msp-riskmap',
  templateUrl: './msp-riskmap.component.html'
})
export class MspRiskmapComponent implements OnInit {

// x - probability
// y - impact
  constructor() { }
  @Input() companyData;

  riskGradient = [
    '#FF0000',
    '#FF3800',
    '#FF7100',
    '#FFAA00',
    '#FFE200',
    '#E2FF00',
    '#A9FF00',
    '#71FF00',
    '#38FF00',
    '#00FF00'];

  public lineChartData:Array<any> = [
  ];
  public lineChartOptions:any = {
    responsive: true,
    chartArea: {
      backgroundGradientPoints: [
        {position: 0.0, color: 'rgba(255, 0, 0, .4)'},
        {position: 0.7, color: 'rgba(255, 255, 0, .4)'},
        {position: 1.0, color: 'rgba(0, 255, 0, .4)'},
      ]
    },
    scales: {
      xAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'Probability'
        },
        ticks: {
          min: 0,
          max: 100
        }
      }],
      yAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'Impact'
        },
        ticks: {
          min: 0,
          max: 100
        }
      }]
    },
    tooltips: {
      displayColors: false,
      callbacks: {
        title(tooltipItem, data) {
          return data.datasets[tooltipItem[0].datasetIndex].label;
        },
        label: this.getTooltipLabel
      }
   }
  };
  public lineChartColors:Array<any> = [];
  public lineChartLegend = false;
  public lineChartType = 'scatter';

  ngOnInit() {
    for (const company of this.companyData) {
      this.lineChartData.push({data: [{x:company.x, y: company.y}], label: company.name});
      this.lineChartColors.push({
        backgroundColor: this.getRiskColor((company.x + company.y) / 2) + 'E0',
        borderColor: this.getRiskColor((company.x + company.y) / 2),
        pointBackgroundColor: this.getRiskColor((company.x + company.y) / 2) + 'C0',
        pointBorderColor: '#009688' + 'E0',
        pointHoverBackgroundColor: this.getRiskColor((company.x + company.y) / 2) + 'FF',
        pointHoverBorderColor: '#009688',
        pointRadius: 4,
        pointHoverRadius: 6
      });
    }
  }

  public getTooltipLabel(tooltipItem, data) {
    const avg = (data.datasets[tooltipItem.datasetIndex].data[0].x + data.datasets[tooltipItem.datasetIndex].data[0].y)/2;
    const lvl = Math.floor(avg / 10);
    let risk = 'Low';
    if (lvl <= 3) {
      risk = 'High';
    } else if (lvl <= 6) {
      risk = 'Medium';
    }
    return ['Probability: ' + tooltipItem.xLabel, 'Impact: ' + tooltipItem.yLabel, 'Risk: ' + risk];
  }

  // events
  public chartClicked(e:any):void {
    console.log(e);
  }

  public chartHovered(e:any):void {
    console.log(e);
  }

  private getRiskColor(val) {
    const lvl = Math.floor(val / 10);
    return this.riskGradient[lvl];
  }

  private getRiskLabel(val) {
    const lvl = Math.floor(val / 10);
    if (lvl <= 3) {
      return 'High';
    } else if (lvl <= 6) {
      return 'Medium';
    } else {
      return 'Low';
    }
  }
}
